export default __webpack_public_path__ + "static/media/teambuilder.3356e6ec.png";